// Stage cleaning page.


// Give button to call prepareStageCleaning.
// Take out stage.
// Put it back
// Verify locks
// Move pusher to home, home loader.
// Ready for use.
import React, {Component, useState} from "react";
import {Button, Col, Layout, message, Row, Spin, Steps} from "antd";

import axios from "axios";
import {AuthHeader} from "../../helper/auth.token";
import {globalUrlPrefix} from "../../utils/const";

import "./c240_stage_cleanup.css";
import {ArrowRightOutlined, CheckCircleOutlined, CloseCircleOutlined} from "@ant-design/icons";

const { Step } = Steps;

const { Content } = Layout;

function call(endpoint, options="", callback=null, show_info=true) {
    // callback is called on 200 response code with response.data as argument
    let url = `/server/scano/1/api~` + endpoint + "/" + options;
    console.log("path ", url, options);
    axios.get(url, { headers: { Authorization: AuthHeader() } })
        .then(response => {
            console.log("STAGE_CLEANING::: ", response);
            if (response.status !== 200) {
                if (callback !== null) {
                    callback(true, response);
                }
            } else {
                if (callback !== null) {
                    callback(false, response);
                }
            }
        })
        .catch(err => {
            console.error(err);
            if (callback !== null) {
                callback(true, err);
            }
        })
};


const ImageComparison = ({ leftImageSrc, rightImageSrc }) => {
    return (
        <Row justify="space-between" align="middle">
            <Col span={11}>
                <div style={{ position: 'relative', paddingRight: '16px'}}>
                    <img style={{height: "200px", width: "200px"}} src={leftImageSrc} alt="Left Image" />
                    <div style={{ position: 'absolute', top: '10px', left: '10px' }}>
                        <CloseCircleOutlined style={{ fontSize: "24px", color: 'red' }} />
                    </div>
                </div>
            </Col>
            <Col span={11}>
                <div style={{ position: 'relative', paddingLeft: '16px'}}>
                    <img style={{height: "200px", width: "200px"}} src={rightImageSrc} alt="Right Image" />
                    <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
                        <CheckCircleOutlined style={{ fontSize: "24px", color: 'green' }} />
                    </div>
                </div>
            </Col>
        </Row>
    );
};

const ImageTransformation = ({image1, image2}) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
                style={{height: "200px", width: "200px"}}
                src={image1}
                alt={"i-1"}
            />
            <ArrowRightOutlined style={{ fontSize: '32px', margin: '0 20px' }} />
            <img
                style={{height: "200px", width: "200px"}}
                src={image2}
                alt={"i-2"}
            />
        </div>
    );
};

function Message({ type, text }) {
    return (
        <div className={`message ${type}`}>
            <div className={`message-tag-`}>

            </div>
            <p>{text}</p>
        </div>
    );
}
function StageCleanupPrepareMachine(props) {

    let [operationFailed, setOperationFailed] = useState(undefined)
    let [displayMessage, setDisplayMessage] = useState("");
    function responseHandler(err, response) {
        setOperationFailed(true);
        if (err) {
            setDisplayMessage("Some issue occurred while preparing for stage removal, please contact Morphle Support.");
        } else {
            let message = response.data;
            if (message === "REMOVAL_PREPARATION_SUCCESSFUL") {
                setOperationFailed(false);
                // move to next step.
                setDisplayMessage("Stage can be removed, moving to next operation...");
            } else if (message === "SCANNER_IS_BUSY") {
                // move to next step.
                setDisplayMessage("Scanner is busy, please wait till scanner finishes remaining tasks.");
            } else if (message === "GATE_IS_OPEN") {
                // move to next step.
                setDisplayMessage("Scanner gate is open, please close the gate before starting cleanup routine.");
            } else {
                setDisplayMessage("Some issue occurred while preparing for stage removal, please contact Morphle Support.");
            }
        }
    }
    function initStageRemoval() {
        var endpoint = "stage_cleaning~init"
        call(endpoint, "", responseHandler);
    }

    return (
            <Row>
                <Row style={{display: "flex", justifyContent: "center", marginBottom: "20px"}}>
                    <Spin spinning={props.stageCleanupState === "PREPARE_FOR_STAGE_REMOVAL" ? true : false}>
                        <Button className={"action-button"} onClick={initStageRemoval}>Initiate stage removal preparation</Button>
                    </Spin>
                </Row>
                <Row>
                    <h3>This will perform following actions:</h3>
                </Row>
                <Row>
                    <ul>
                        <li>If there is any cassette on stage, it will place it in rack.</li>
                        <li>Move Loader & Pusher to safe position.</li>
                    </ul>
                </Row>
                <Row>
                    {operationFailed !== undefined ? (
                        operationFailed ? (
                            <Message type={"error"} text={displayMessage} />
                        ):(
                            <Message type={"success"} text={displayMessage} />
                        )
                    ) : null}
                </Row>
                <Row>
                    {operationFailed ? <a href={"/" + globalUrlPrefix + "/c240_control_panel/" + props.deviceId}>
                        Go to Scanner
                    </a> : null}
                </Row>
            </Row>
    );
}

function RemoveStageComponent(props) {

    const [stageRemoved, setStageRemoved] = useState(false);

    function updateStatus(state) {
        var endpoint = "stage_cleaning~update_status"
        call(endpoint, "?state="+state);
        setStageRemoved(true);
    }

    return (
          <Row style={{marginBottom: "20px"}}>
              <Row>
                  <h4>Use T-shaped tool to open front door.</h4>

                  <Row style={{marginBottom: "20px", display: "flex"}}>
                      <img style={{marginRight: "20px", height: "200px", width: "200px"}} src={"/dev-ssd/stage_cleanup_assets/t_shaped_tool.jpg"} />
                      <ImageTransformation image1={"/dev-ssd/stage_cleanup_assets/front_door_closed.jpg"} image2={"/dev-ssd/stage_cleanup_assets/front_door_open.jpg"} />
                  </Row>
              </Row>

              <Row>
                  <h4>Use T-shaped tool to unlock stage, by rotating below screw (You can find it on the left side, just near front door).</h4>
                  <Row style={{marginBottom: "20px", display: "flex"}}>
                      <img style={{marginRight: "20px", height: "200px", width: "200px"}} src={"/dev-ssd/stage_cleanup_assets/stage_rotate.jpg"} />
                      <ImageTransformation image1={"/dev-ssd/stage_cleanup_assets/locked_stage.jpg"} image2={"/dev-ssd/stage_cleanup_assets/stage_unlocked.jpg"} />
                  </Row>
              </Row>

              <Row style={{marginBottom: "20px"}}>
                  <h4>Pull stage outside the scanner (If you are unable to pull, make sure above step was performed correctly).</h4>
                  <img style={{height: "200px", width: "200px"}} src={"/dev-ssd/stage_cleanup_assets/pull_stage.jpg"} />
              </Row>

              <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
                  {
                      !stageRemoved ? <Button className={"action-button"} onClick={() => updateStatus("STAGE_REMOVED")}>Confirm Stage is removed</Button> : <Message type={"success"} text={"Stage Removed"} />
                  }
              </div>
          </Row>
    );
}

function InsertStageComponent(props) {

    const [stageInserted, setStageInserted] = useState(false);

    function updateStatus(state) {
        let endpoint = "stage_cleaning~update_status"
        call(endpoint, "?state="+state);
        setStageInserted(true);
    }

    return (
            <Row>
                <Row>
                    <h5>Use IPA to clean the stage.</h5>
                    <h4>After Cleaning:</h4>
                </Row>

                <Row style={{marginBottom: "20px"}}>
                    <h4>
                        Insert stage, follow white stripes:
                    </h4>

                    <img style={{height: "200px", width: "200px"}} src={"/dev-ssd/stage_cleanup_assets/insert_on_white_stripes.jpg"} />
                </Row>

                <Row style={{marginBottom: "20px"}}>
                    <h4>Lock stage using T-shaped tool</h4>
                    <ImageTransformation image1={"/dev-ssd/stage_cleanup_assets/stage_unlocked.jpg"} image2={"/dev-ssd/stage_cleanup_assets/locked_stage.jpg"} />
                </Row>

                <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
                    {
                        !stageInserted ? <Button className={"action-button"} onClick={() => updateStatus("STAGE_INSERTED")}>Confirm Stage is inserted</Button> : <Message type={"success"} text={"Stage Inserted"} />
                    }
                </div>
            </Row>
    );
}
function VerifyStagePlacementComponent(props) {

    let [endRoutineLoader, setEndRoutineLoader] = useState(false);

    function endRoutine() {
        let endpoint = "stage_cleaning~end_routine";
        call(endpoint, "", () => {
            setEndRoutineLoader(true)
            message.success("Stage Clean up operation completed successfully.");
            window.location = "/" + globalUrlPrefix + "/c240_control_panel/" + props.deviceId;
        })
    }

    let imageUrl1 = "/dev-ssd/stage_cleanup_assets/holder_incorrect.jpg";
    let imageUrl2 = "/dev-ssd/stage_cleanup_assets/holder_correct.jpg";
    let imageUrl3 = "/dev-ssd/stage_cleanup_assets/window_incorrect.jpg";
    let imageUrl4 = "/dev-ssd/stage_cleanup_assets/window_correct.jpg";

    return (
        <Row>
            <Row style={{marginBottom: "30px"}}>
                <h4>Stage should fit correctly in the holder: </h4>
                <ImageComparison leftImageSrc={imageUrl1} rightImageSrc={imageUrl2} />
            </Row>

            <Row style={{marginBottom: "30px"}}>
                <h4>Front door should close properly: </h4>
                <ImageComparison leftImageSrc={imageUrl3} rightImageSrc={imageUrl4} />
            </Row>

            <Row>
                <Spin spinning={endRoutineLoader}>
                    <Button className={"action-button"} onClick={endRoutine}>
                        Confirm Stage Placement & End Routine
                    </Button>
                </Spin>
            </Row>
        </Row>
    )
}
class C240StageCleanUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stageCleanupState: "INITIAL",
            currentStep: 0,
            steps: [
                {
                    title: 'Prepare',
                    description: 'Prepare Scanner for stage cleanup',
                },
                {
                    title: 'Remove Stage',
                    description: 'Remove Stage',
                },
                {
                    title: 'Insert Stage',
                    description: 'Clean & Insert Stage',
                },
                {
                    title: 'Confirmation',
                    description: 'Confirm stage is placed correctly',

                }
            ]
        };

        this.poller = null;

    }

    moveToNextStep = () => {
        console.log("Moving to next")
        this.setState({currentStep: this.state.currentStep + 1})
    }

    stageCleanupStatusResponseHandler = (err, response) => {
        console.log("STAGE:: ", response);

        if (err) {

        } else {
            let message = response.data;
            if (message === "INITIAL" || message === "PREPARE_FOR_STAGE_REMOVAL") {
                if (this.state.currentStep !== 0) {
                    this.setState({currentStep: 0});
                }
            } else if (message === "STAGE_REMOVAL_IN_PROGRESS") {
                if (this.state.currentStep !== 1) {
                    this.setState({currentStep: 1});
                }
            } else if (message === "STAGE_REMOVED") {
                if (this.state.currentStep !== 2) {
                    this.setState({currentStep: 2});
                }
            } else if (message === "STAGE_INSERTED") {
                if (this.state.currentStep !== 3) {
                    this.setState({currentStep: 3});
                }
            }

            this.setState({stageCleanupState: message});
        }
    }

    componentDidMount() {
        // fetch stage cleanup state.
        let endpoint = "stage_cleaning~poll_stage_cleanup_status"
        call(endpoint, "", this.stageCleanupStatusResponseHandler);
        this.poller = setInterval(() => {
            call(endpoint, "", this.stageCleanupStatusResponseHandler);
        }, 1500);
    }

    componentWillUnmount() {
        clearInterval(this.poller);
    }

    render() {
        const { currentStep, steps } = this.state;
        const deviceId = this.props.match.params.id;

        let stepComponent;
        switch (currentStep) {
            case 0:
                stepComponent = <StageCleanupPrepareMachine stageCleanupState={this.state.stageCleanupState}  deviceId={deviceId} moveToNext={this.moveToNextStep} />
                break;
            case 1:
                stepComponent = <RemoveStageComponent stageCleanupState={this.state.stageCleanupState} moveToNext={this.moveToNextStep} />
                break;
            case 2:
                stepComponent = <InsertStageComponent stageCleanupState={this.state.stageCleanupState} moveToNext={this.moveToNextStep} />
                break;
            case 3:
                stepComponent = <VerifyStagePlacementComponent moveToNext={this.moveToNextStep} deviceId={deviceId} stageCleanupState={this.state.stageCleanupState} />
                break;
            default:
                stepComponent = <StageCleanupPrepareMachine moveToNext={this.moveToNextStep} stageCleanupState={this.state.stageCleanupState} />
                break;
        }


        return (
            <Content className={"stage-maintenance-container"} style={{ padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Row style={{width: "80%"}}>
                    <Col>
                        <Row className={"stage-cleanup-header"} style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px"}}>
                            <a href={"/" + globalUrlPrefix + "/c240_settings/" + deviceId}>
                                <Button className={"nav-button"}>Go back to settings</Button>
                            </a>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                                <h1 style={{fontSize: "38px", paddingTop: "20px"}}>Stage Maintenance</h1>
                            </div>
                            <a href={"/" + globalUrlPrefix + "/c240_control_panel/" + deviceId}>
                                <Button className={"nav-button"}>Go to scanner</Button>
                            </a>
                        </Row>
                        <Row style={{marginTop: "100px"}}>
                            <Steps current={currentStep}>
                                {steps.map((step, index) => (
                                    <Step key={index} title={step.title} />
                                ))}
                            </Steps>
                            <Content style={{ backgroundColor: "#F0F6FC", marginTop: '50px',  padding: '24px', display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: 'center', boxShadow: "inset 0 0 2px rgba(0, 0, 0, 0.15)" }}>
                                <Row>
                                    <h2>{currentStep + 1 + ". "} {steps[currentStep].description}</h2>
                                </Row>
                                <Row style={{marginTop: "20px"}}>
                                    {stepComponent}
                                </Row>
                            </Content>
                        </Row>
                    </Col>
                </Row>
            </Content>
        );
    }
}

export default C240StageCleanUp;